package com.fireavert.administration.users_page.main_user_page.client.presentation

import com.fireavert.administration.users_page.main_user_page.data_models.data_model.UserTrackingRecord

data class UserTrackingViewState(
    val loading: Boolean = true,
    val userTrackingRecords: List<UserTrackingRecord> = emptyList()
)